<template>
  <d-card
    v-if="returns && returns.length"
    class="mt-4">
    <table class="table mt-0 mb-0 full-width">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0" style="width: 250px;">{{ $t('order.hafciarnia.embrioderyReturns.createdAt') }}</th>
          <th scope="col" class="border-0" style="width: calc(100% - 600px);">{{ $t('order.hafciarnia.embrioderyReturns.products') }}</th>
          <th scope="col" class="border-0" style="width: 350px;">{{ $t('order.hafciarnia.embrioderyReturns.status') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(returnItem, index) of returns"
          :key="'embriodery-return-item-' + index">
          <td class="align-middle">
            {{ returnItem.created_at }}
          </td>
          <td class="align-middle">
            <div
              v-for="(product, subindex) of returnItem.products"
              :key="'embriodery-return-item-' + index + '-' + subindex">
              <small>{{ product.product_code }} - {{ product.quantity }} {{ $t('ui.piecesAbbr') }}</small>
            </div>
          </td>
          <td class="align-middle">
            <template v-if="returnItem.status === 'TO_RETURN'">
              {{ $t('order.hafciarnia.embrioderyReturns.statuses.toReturn') }}
            </template>
            <template v-if="returnItem.status === 'RETURNED'">
              {{ $t('order.hafciarnia.embrioderyReturns.statuses.returned') }}
            </template>
            <template v-if="returnItem.status === 'RECEIVED_IN_HPL'">
              {{ $t('order.hafciarnia.embrioderyReturns.statuses.receivedInHPL') }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </d-card>
</template>

<script>
export default {
  name: 'order-returns',
  props: [
    'returns'
  ]
}
</script>
